const applyUiScaling = (scale: number) => {
  document
    .querySelector('meta[name="viewport"]')
    .setAttribute("content", `width=device-width, initial-scale=${scale}`);
};

export {applyUiScaling};
